import { FeatureFlag, Site } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsInfo, createForm } from '@ps/web-shared-ui';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { styles as sharedStyles } from '@swf/account';
import { getEulaTypes } from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes';
import useFeature from '@swf/core/hooks/useFeature';
import type { RegisterPayload } from '@swf/core/models/auth/register';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { RegistrationStyles } from '../../StarsAuth';

import {
  TXTCLI_For_the_purposes_of_responsibl_ELL,
  TXTCLI_If_you_are_interested_in_imple_ELL,
  TXTWCL_Nearly_doneX
} from './RegistrationEula.messages.json';
import type { RegistrationEulaFormValues } from './RegistrationEulaFields';
import RegistrationEulaFields from './RegistrationEulaFields';

const getInitialValues = (siteId: Site, separatedEulaPrivacyPolicy: boolean) => ({
  marketingMailList: false,
  selectAll: false,
  ...getEulaTypes('stars', siteId, separatedEulaPrivacyPolicy).reduce(
    (result, el) => ({ ...result, [el]: false }),
    {}
  )
});

const Form = createForm<RegistrationEulaFormValues>();

const RegistrationEula: React.FC = () => {
  const { state: locationState } = useLocation<Omit<RegisterPayload, 'marketingMailList'>>();
  const siteId = useSelector(select.cms.getSiteId);
  const separatedEulaPrivacyPolicy = useFeature(FeatureFlag.SeparatedEulaPrivacyPolicy);
  const {
    auth: { register }
  } = useDispatch<Dispatch>();

  const handleSubmit = useCallback(
    ({ marketingMailList = false }: { marketingMailList: boolean }) =>
      register({ marketingMailList, ...locationState }),
    [register, locationState]
  );

  return (
    <RegistrationStyles.Consumer>
      {(registrationStyles) => (
        <>
          <h2 className={registrationStyles.title}>
            <Translation {...TXTWCL_Nearly_doneX} />
          </h2>
          <Form
            onSubmit={handleSubmit}
            initialValues={getInitialValues(siteId, separatedEulaPrivacyPolicy)}
          >
            <RegistrationEulaFields />
          </Form>
          {siteId === Site.USNJ && (
            <div className={sharedStyles.message}>
              <StarsInfo>
                <Translation {...TXTCLI_For_the_purposes_of_responsibl_ELL} />{' '}
                <Translation {...TXTCLI_If_you_are_interested_in_imple_ELL} />
              </StarsInfo>
            </div>
          )}
        </>
      )}
    </RegistrationStyles.Consumer>
  );
};

export default RegistrationEula;
